import { ServiceAppService } from './../../../../security/service-app.service';
import { FileUpload } from './../../../../shared/fileupload/fileupload';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { AtivacaoServicesListaService } from './ativacao-services-lista.service';

@Component({
  selector: 'app-ativacao-services-lista',
  templateUrl: './ativacao-services-lista.component.html',
  styleUrls: ['./ativacao-services-lista.component.scss']
})

export class AtivacaoServicesListaComponent implements OnInit {

  cols: any[];

  first = 0;
  rows = 10;
  edit = false;

  dados: any[];
  enviaArquivo: any;

  _selectedColumns: any[];

  CategoriaFiltro = [];

  dado: any;
  selectedDados: any[];
  dadosExibicao = [];

  isCollapsed = true;
  tipoArquivo: any;
  loading: boolean;

  dadosDialog: boolean;
  submitted: boolean;
  dadosModal: boolean;

  codigos = [];

  displayImport: boolean = false;
  displayFiltros: boolean = false;

  totalPercent = 0;
  progressBarPerc: any;
  percentDone: number;
  selectedFile: any;
  localUrl: any[];

  progress = false;
  dataInicio: Date;
  dataFim: Date;

  checked: boolean;

  filtros = {
    codigo: null,
    categoriaItem: '',
    classificacao: ''
  }

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private service: ServiceAppService,
    private ativacaoService: AtivacaoServicesListaService,
    private config: PrimeNGConfig,
    private date: DatePipe) { }

  ngOnInit(): void {
    this.retornaDados();
    this.progressBarPerc = 0;

    this.cols = [
      { field: 'idDealer', header: 'Id Dealer' },
      { field: 'codDealer', header: 'Código Dealer' },
      { field: 'nome', header: 'Nome' },
      { field: 'processo', header: 'Processo' },
      { field: 'versao', header: 'Versão' },
      { field: 'status', header: 'Status' },
      { field: 'visivel', header: 'Visibilidade', width: '50px' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados('/ativacao_service').subscribe(res => {
      this.dados = res.dados;
      this.codigos = [];
      this.dados.forEach(usuario => {
        this.codigos.push({ label: usuario.nome, value: usuario.codDealer });
      });
      this.loading = false;
    });
  }

  recarregaDados() {
    this.dt.first = 0;

    this.retornaDados();
  }

  showDialog() {
    this.displayImport = true;
  }

  progressReport(event) {
    this.fileUpload.progress = event;
  }

  onRemoveFile(event?) {
    this.progressBarPerc = 0;
  }

  removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
  }

  processarArquivo(dado) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja processar o arquivo?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      key: 'importacaoArquivoHonda',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const formData = new FormData();

        formData.append("id", dado.id.toString());

        this.dados.forEach(dados => {
          if (dados.id == dado.id) {
            dados.status = 2;
          }
        });
      }
    });
  }

  showFiltrosAvancados() {
    this.displayFiltros = true;
  }

  hideFiltrosAvancados() {
    this.displayFiltros = false;
  }

  filtrosAPI() {
    if (this.filtros.codigo != '') {
      this.dt.filter(this.filtros.codigo, 'codigo', 'equals');
    } else {
      this.dt.filter('', 'codigo', 'equals');
    }

    this.retornaDados();
  }

  limpafiltros(event) {
    // this.filtros = {
    //   //codDealer: null
    // }

    this.dt.filter('', 'codDealer', 'equals');
  
    this.retornaDados();
  }

  alteraVisibilidade(rowData) {
    this.ativacaoService.ativacaoServicoAlteraVisibilidade(`ativacao_service/${rowData.idDealer}/${rowData.processo}/${rowData.visivel}`).subscribe(res => {
      this.messageService.add({ severity: 'success', summary: 'Visibilidade alterada com sucesso', detail: 'Via MessageService' });
      this.retornaDados();
    })
  }
}